import { useContext } from 'react';
import { RichTextEditorContext } from '../components/RichTextEditorProvider';

export const useRichTextEditorContext = () => {
  return useContext(RichTextEditorContext);
};
